import { GLOBAL_TINI, TINI_APP_CONTEXT, SPLASHSCREEN_ID, NO_APP_ERROR, } from './consts';
export function asset(path) {
    return path;
}
export function isClass(input) {
    return (typeof input === 'function' &&
        /^class\s/.test(Function.prototype.toString.call(input)));
}
export function getDIRegistry() {
    return (GLOBAL_TINI.DIRegistry || (GLOBAL_TINI.DIRegistry = {
        registers: new Map(),
        instances: new Map(),
        awaiters: [],
    }));
}
export function getContext() {
    return TINI_APP_CONTEXT;
}
export function getApp() {
    if (!GLOBAL_TINI.app)
        throw NO_APP_ERROR;
    return GLOBAL_TINI.app;
}
export function getOptions() {
    return TINI_APP_CONTEXT.options || {};
}
export function getConfigs() {
    return (TINI_APP_CONTEXT.configs || {});
}
export function registerConfigs(configs) {
    return (TINI_APP_CONTEXT.configs = configs);
}
export function registerGlobalHook(componentTypeOrTypes, hookCycleOrCycles, hookAction) {
    // init the registry
    const registry = (GLOBAL_TINI.LHRegistry || (GLOBAL_TINI.LHRegistry = {}));
    // cycles & types
    const componentTypes = typeof componentTypeOrTypes === 'string'
        ? [componentTypeOrTypes]
        : componentTypeOrTypes;
    const hookCycles = typeof hookCycleOrCycles === 'string'
        ? [hookCycleOrCycles]
        : hookCycleOrCycles;
    // organize
    for (let i = 0; i < componentTypes.length; i++) {
        const type = componentTypes[i];
        if (!registry[type])
            registry[type] = {};
        for (let j = 0; j < hookCycles.length; j++) {
            const cycle = hookCycles[j];
            if (!registry[type][cycle])
                registry[type][cycle] = [];
            registry[type][cycle].push(hookAction);
        }
    }
    // result
    return registry;
}
export function getGlobalHooks(type, cycle) {
    var _a, _b;
    return (_b = (_a = GLOBAL_TINI.LHRegistry) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b[cycle];
}
export function runGlobalHooks(cycle, component) {
    const globalHooks = getGlobalHooks(component.constructor.componentType, cycle);
    const data = {
        source: component,
        app: getApp(),
        appContext: getContext(),
    };
    globalHooks === null || globalHooks === void 0 ? void 0 : globalHooks.forEach(action => action(data));
    return globalHooks;
}
export function getSplashscreen() {
    return document.getElementById(SPLASHSCREEN_ID) || undefined;
}
export function hideSplashscreen() {
    const node = getSplashscreen();
    if (!node)
        return;
    if (node.hide instanceof Function) {
        node.hide();
    }
    else {
        node.remove();
    }
}
export function stylingWithBases(bases, additionalStyling) {
    // bases
    const styling = bases.reduce((result, item) => {
        Object.keys(item).forEach(key => {
            result[key] || (result[key] = []);
            result[key].push(item[key]);
        });
        return result;
    }, {});
    // more
    if (additionalStyling) {
        Object.keys(additionalStyling).forEach(key => {
            styling[key] || (styling[key] = []);
            styling[key].push(...additionalStyling[key]);
        });
    }
    // result
    return styling;
}
//# sourceMappingURL=methods.js.map